export default function About() {
  return (
    <section id="about" className="bg-[#1f2937] py-16 sm:py-24 lg:py-32 px-4 sm:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6 sm:space-y-8">
            <div className="flex items-center gap-2 text-xs sm:text-sm uppercase tracking-wide text-[#718096]">
              <span className="w-2 h-2 bg-[#8B6914] rounded-full"></span>
              THE MAKER'S PATH
            </div>

            <div className="relative">
              <span className="absolute -left-4 sm:-left-8 -top-2 sm:-top-4 text-[48px] sm:text-[96px] text-[#8B6914] font-serif leading-none">"</span>
              <h2 className="text-[32px] sm:text-[48px] lg:text-[64px] font-serif text-[#F7F7F7] leading-tight" style={{ lineHeight: '1.3' }}>
                Every weapon tells a story of discipline, precision, and the warrior's code.
              </h2>
            </div>

            <div className="flex items-center gap-4 pt-4 sm:pt-8">
              <div>
                <p className="text-base sm:text-lg font-bold text-[#F7F7F7]">Master Craftsman</p>
                <p className="text-xs sm:text-sm text-[#718096]">Founder & Weapon Smith</p>
              </div>
              <div className="w-10 h-10 bg-[#8B6914] rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
            </div>

            <p className="text-base sm:text-lg text-[#A0AEC0] leading-relaxed pt-4 sm:pt-6">
              Founded by a skilled carpenter with a lifelong passion for building and self-reliance, Dark Warrior Weapons creates functional, durable, and visually striking melee weapons for collectors, enthusiasts, and individuals who value preparedness. Each weapon is built with precision using high-quality materials and traditional woodworking techniques combined with modern design.
            </p>

            <p className="text-base sm:text-lg text-[#A0AEC0] leading-relaxed">
              We believe people should have access to tools that help them feel confident, capable, and protected. Whether for collection, training, display, or lawful personal defense, our weapons are designed to be reliable and built to last.
            </p>

            {/* New Preparedness Section */}
            <div className="bg-[#2d3748] rounded-xl sm:rounded-2xl p-6 sm:p-8 border-l-4 border-[#8B6914]">
              <div className="flex items-start gap-3 mb-4">
                <i className="ri-shield-star-line text-[#8B6914] text-2xl sm:text-3xl mt-1"></i>
                <h3 className="text-xl sm:text-2xl font-bold text-[#F7F7F7]">Always Be Prepared</h3>
              </div>
              <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed mb-4">
                The founder's background as a Boy Scout instilled a core principle that guides everything we do: <strong className="text-[#F7F7F7]">Be Prepared</strong>. This isn't just a motto—it's a way of life. In uncertain times, whether facing natural disasters, civil unrest, or even the possibility of martial law, the ability to defend yourself and your loved ones is not just a right—it's a responsibility.
              </p>
              <p className="text-sm sm:text-base text-[#A0AEC0] leading-relaxed">
                We create tools for those who understand that self-reliance and preparedness are essential. When systems fail and order breaks down, you need to be ready. Our weapons are built for people who refuse to be helpless, who take their safety seriously, and who believe in the fundamental right to protect what matters most.
              </p>
            </div>
          </div>

          {/* Right Visual Zone */}
          <div className="relative h-[500px] sm:h-[600px] lg:h-[700px] mt-8 lg:mt-0">
            {/* Top Left Card */}
            <div className="absolute top-0 left-0 w-[200px] sm:w-[300px] lg:w-[400px] h-[200px] sm:h-[300px] lg:h-[400px] rounded-xl sm:rounded-2xl overflow-hidden border-4 sm:border-8 border-[#0d1117] shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/025323e9f50e8f5a78801b6dff758601.jpg"
                alt="Craftsmanship Detail"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Bottom Right Card */}
            <div className="absolute bottom-0 right-0 w-[220px] sm:w-[350px] lg:w-[450px] h-[300px] sm:h-[450px] lg:h-[600px] rounded-xl sm:rounded-2xl overflow-hidden border-4 sm:border-8 border-[#0d1117] shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=full%20length%20handcrafted%20wooden%20melee%20weapon%20staff%20or%20club%20displayed%20vertically%20in%20dramatic%20side%20lighting%20against%20pure%20black%20background%20showcasing%20craftsmanship%20balance%20and%20design%20professional%20product%20photography%20moody%20atmospheric%20lighting%20emphasizing%20wood%20grain%20and%20form&width=450&height=600&seq=weapon-full-001&orientation=portrait"
                alt="Handcrafted Weapon"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Stats */}
            <div className="absolute top-0 right-0 flex gap-6 sm:gap-12 lg:gap-16">
              <div className="text-right">
                <div className="text-[36px] sm:text-[56px] lg:text-[72px] font-bold text-[#8B6914] leading-none">500+</div>
                <div className="text-[10px] sm:text-xs uppercase tracking-wide text-[#718096] mt-1 sm:mt-2">Weapons Forged</div>
              </div>
              <div className="text-right">
                <div className="text-[36px] sm:text-[56px] lg:text-[72px] font-bold text-[#8B6914] leading-none">8 YRS</div>
                <div className="text-[10px] sm:text-xs uppercase tracking-wide text-[#718096] mt-1 sm:mt-2">Master Craft</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
